import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { random } from 'lodash-es';
import React from 'react';

type Item = string | number;

const emojis = ['🐵', '🐶', '🐺', '🦊', '🦝', '🐱', '🦁', '🐯', '🐮', '🐷', '🐭', '🐹', '🐰', '🐻', '🐻‍❄️', '🐨', '🐼'];

export interface SelectProps extends StandaloneComponentProps {
  label: string;
  items: Item[] | readonly Item[];
  onChange: (value: any) => void;
  defaultValue?: string | number;
  disabled?: boolean;
}

export const Select: StandaloneComponent<SelectProps> = ({ label, items, onChange, defaultValue, disabled }) => {
  const handleOnChange: React.ChangeEventHandler<HTMLSelectElement> = ({ target: { value } }) => {
    onChange(value || undefined);
  };

  return (
    <label className="space-x-2">
      <span>{label}:</span>
      <select onChange={handleOnChange} {...{ defaultValue }} disabled={disabled}>
        <option value={''} suppressHydrationWarning>
          {emojis[random(0, emojis.length - 1)]}
        </option>
        {items.map((variant) => (
          <option key={variant} value={variant}>
            {variant}
          </option>
        ))}
      </select>
    </label>
  );
};
